import React, { useEffect, useRef } from 'react';
import {
  Container, Grid, useMediaQuery, useTheme, Box,
} from '@mui/material';
import StyledBox from 'views/information-module/common/components/UI/FranchiseCommonSections/FranchiseCommonSections.styles';
import {
  FranchiseHeader,
  FranchiseTitleWithImg,
  FranchiseHorizontalTabBar,
  FranchiseAsideBar,
} from 'views/information-module/common/components';
import { useTranslation } from 'next-i18next';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';

const FranchiseCommonSections = (props) => {
  const {
    activeTab,
    verticaltabs,
    titleWithImage,
    titleWithImgText,
    children,
  } = props;
  const franchiseContent = useRef();
  const { t } = useTranslation('fe_er_common_franchise_header');
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.down('lg'));
  const horizontaltabs = [
    {
      label: t('fe_er_common_franchise_header:overview'),
      value: 1,
      href: PATHS.franchise.index(),
      component: NavigatorLink,
    },
    {
      label: t('fe_er_common_franchise_header:about_us'),
      value: 2,
      href: PATHS.franchise.aboutUs(),
      component: NavigatorLink,
    },
    {
      label: t('fe_er_common_franchise_header:support'),
      value: 3,
      href: PATHS.franchise.support(),
      component: NavigatorLink,
    },
    {
      label: t('fe_er_common_franchise_header:join'),
      value: 4,
      href: PATHS.franchise.becomingFranchise(),
      component: NavigatorLink,
    },
    {
      label: t('fe_er_common_franchise_header:rebrand'),
      value: 5,
      href: PATHS.franchise.rebranding(),
      component: NavigatorLink,
    },
    {
      label: t('fe_er_common_franchise_header:market_opportunities'),
      value: 6,
      href: PATHS.franchise.marketOpportunities(),
      component: NavigatorLink,
    },
    {
      label: t('fe_er_common_franchise_header:international'),
      value: 7,
      href: PATHS.franchise.international(),
      component: NavigatorLink,
    },
  ];
  useEffect(() => {
    franchiseContent.current?.scrollIntoView();
  }, []);
  return (
    <StyledBox>
      <FranchiseHeader />
      <Box className="FCSNavCont">
        <Container maxWidth="xl" ref={franchiseContent}>
          <FranchiseHorizontalTabBar
            activeTab={activeTab}
            tabs={horizontaltabs}
          />
        </Container>
      </Box>
      <Container maxWidth="xl">
        <Grid container pt={4} className="FCSContent">
          <Grid item xs={12} lg={3} className="FCSGridorder FCSTabs">
            {isDesktop ? (
              <Box mt={3}>
                <FranchiseHorizontalTabBar tabs={verticaltabs} />
              </Box>
            ) : (
              <FranchiseAsideBar tabs={verticaltabs} orientation="vertical" />
            )}
          </Grid>
          <Grid item xs={12} lg={9} className="FCSGridorder">
            <FranchiseTitleWithImg
              title={titleWithImgText}
              image={titleWithImage}
            />
          </Grid>
          <Grid item xs={12} lg={3} className="FCSGridorder" />
          <Grid item xs={12} lg={9} mt={2} className="FCSGridorder">
            {children}
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { FranchiseCommonSections };
